import React from "react";
import PageHeader from "../components/PageHeader";
import Projects from "../components/Projects";

const Project = () => {
  return (
    <>
      <PageHeader title="Projects" />
      <Projects />
    </>
  );
};

export default Project;
